export default function authorizationHeader(headers?: any) {
  return {
    ...headers,
    Authorization: `Bearer ${window.localStorage.token}`,
  }
}
